import getFromCdn from '@anm/helpers/getFromCdn';
import { NextPage } from 'anm-next';
import compose from 'lodash/fp/compose';
import React from 'react';

import bootstrapPage, { BootstrapPageProps } from '../HOCs/bootstrapPage';
import injectSagasAndReducers from '../HOCs/injectSagasAndReducers';
import MetaHead from '../components/MetaHead';
import Layout from '../components/layouts/Layout';
import PricingSubscriptionContent from '../components/pricing/PricingSubscriptionContent';
import useInitStripe from '../hooks/pricing/useInitStripe';
import pricingReducer, { pricingActions, pricingSaga } from '../store/modules/pricing';
import subscriptionReducer, { subscriptionSaga } from '../store/modules/subscription';

const PricingPage: NextPage<BootstrapPageProps, {}> = ({ path }) => {
  useInitStripe();

  const title = 'Pricing | Wave.video';
  const description =
    "Create, host, and share your videos anywhere with Wave.video. Choose a plan that suits you best. Try now, it's free!";
  const previewUrl = `${getFromCdn('images/data/pricing/wavevideo_pricing_preview.jpg')}`;
  const previewSize = { width: 400, height: 300 };

  return (
    <>
      <MetaHead
        path={path}
        title={title}
        description={description}
        preview={previewUrl}
        size={previewSize}
        includeLangLinks={true}
      />
      <Layout navigationVariant="white">
        <PricingSubscriptionContent />
      </Layout>
    </>
  );
};

PricingPage.getInitialProps = async ({ store }) => {
  store.dispatch(pricingActions.fetchPricingSubscriptionData());
  return {};
};

export default compose(
  bootstrapPage,
  injectSagasAndReducers(
    () => [...pricingSaga(), ...subscriptionSaga()],
    {
      pricing: pricingReducer,
      subscription: subscriptionReducer
    },
    { id: 'PricingPage' }
  )
)(PricingPage);
